<div class="onboarding full-height" data-dgat="onboarding-view-container">
  <dgx-product-header
    [shouldHideGlobalSearch]="true"
    [shouldHideGlobalAdd]="true"
    [shouldHideNotifications]="true"
    [shouldHideHomeLogo]="true"
    [shouldHideCenterOrgLogo]="false"
    [shouldHideUtilityBar]="true"
    [shouldHideProductSwitcher]="true"
    [context]="context"
    [orgId]="orgId"
  ></dgx-product-header>
  <div class="guts-m-t-6 guts-m-b-10 rel onboarding__body oh full-height">
    <router-outlet></router-outlet>
  </div>
  <!-- display a loading overlay on onboarding-->
  <div *ngIf="loading" class="overlay disabled">
    <df-spinner
      class="horizontal-center vertical-center absolute"
      [isSpinning]="loading"
    ></df-spinner>
  </div>
  <footer
    class="is_fixed is_fixed--bottom is_fixed--full-page border-top __footer"
  >
    <dgx-onboarding-footer
      (nextStep)="nextStep($event)"
      (previousStep)="previousStep($event)"
      (skipStep)="skipStep($event)"
      (trackerEvent)="onTrackerClicked($event)"
    ></dgx-onboarding-footer>
  </footer>
</div>
